import Splide from '@splidejs/splide';

export const initPhotoSlider = () => {
  const bgSliderEl = document.querySelector(
    '[data-smart-home-control-photo-frame-background]'
  );

  const bgSlider = new Splide(bgSliderEl, {
    type: 'loop',
    updateOnMove: true,
    focus: 'center',
    rewind: true,
    perPage: 7,
    autoplay: true,
    interval: 3000,
    speed: 1200,
    drag: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    padding: { left: 80, right: 80 },
    arrows: false,
    pagination: false,
    cssEase: 'linear',
    reducedMotion: {
      arrows: true,
      speed: 0,
      rewindSpeed: 0,
      autoplay: 'pause',
    },
    breakpoints: {
      1024: {
        perPage: 5,
      },
      680: {
        perPage: 3,
        padding: 0,
      },
    },
  });

  const deviceSlides = document.querySelectorAll(
    '[data-smart-home-control-photo-frame-device-slide]'
  );

  bgSlider.on('mounted', () => {
    const activeSlideIndex = bgSlider.index;

    deviceSlides[activeSlideIndex].setAttribute('data-active', 'true');
  });

  bgSlider.on('move', (dest) => {
    deviceSlides.forEach((deviceSlide) => {
      deviceSlide.removeAttribute('data-active');
    });

    deviceSlides[dest].setAttribute('data-active', 'true');
  });

  bgSlider.mount();
};
